/**
 * Created by Ivan on 29.05.2025
 */

const ExtraHandTutorial = function () {
    return new TutorialScenario("extrahand", {
        listSteps: () => [
            ExtraHandTutorial.createStep()
        ],

        isAvailable: () => ExtraHandTutorial.isAvailable(),

        onStart: function () {},
        onFinish: function () {
            Game.currentGame.hand.extra.update();
        }
    });
};

ExtraHandTutorial.isAvailable = function () {
    if (!Game.currentGame || cleverapps.environment.isSceneWithPreview()) {
        return false;
    }

    const extraHand = Game.currentGame.hand.extra;

    if (!extraHand.visible || Game.currentGame.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return false;
    }

    const offer = Game.currentGame.prolongation.getOffer(Prolongation.REWARDS.MOVES);

    return offer.type === Product.TYPE_FREE;
};

ExtraHandTutorial.createStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused("undoBlock");

            new ActionPlayer([
                function (f) {
                    setTimeout(f, 250);
                },

                function (f) {
                    const extraHandView = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).handView.extraHandView;
                    const offer = Game.currentGame.prolongation.getOffer(Prolongation.REWARDS.MOVES);

                    cleverapps.forces.create(extraHandView, offer.force);
                    cleverapps.forces.onceForceClosed = f;
                },

                function (f) {
                    setTimeout(f, 500);
                }
            ]).play();

            cleverapps.tutorial.on("clickExtraHand", this.finish.bind(this), this);
        },
        onFinish: function () {
            cleverapps.forces.closeRunningForce();
        }
    });
};